// Phase 29.6.3 · Exception detail — recipient + payload snapshot.

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function ExceptionDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);

  useEffect(() => {
    api.get(`/notifications/${id}`)
      .then((r) => setN(r.data))
      .catch((e) => toast.error(formatApiError(e)));
  }, [id]);

  if (!n) return (
    <div className="p-8 text-center text-neutral-400">
      <Loader2 className="h-5 w-5 inline animate-spin" />
    </div>
  );

  return (
    <div className="p-4 pb-24 space-y-4" data-testid="exc-detail-root"
         data-notif-id={n.id}>
      <div className="text-[11px] uppercase tracking-widest text-neutral-400">
        Exception detail
      </div>
      <h1 className="text-xl font-extrabold text-neutral-900">
        {n.title || n.type}
      </h1>
      <Card className="border-neutral-200 rounded-2xl">
        <CardContent className="p-4 space-y-2 text-sm">
          <Row label="Type" value={n.type} />
          <Row label="Recipient user_id" value={n.recipient_user_id || n.user_id} />
          <Row label="Date" value={n.payload?.date || (n.ts || "").slice(0, 10)} />
          <Row label="Timestamp" value={n.ts} />
          <Row label="Delivered" value={String(n.delivered)} />
          <Row label="Delivery channel"
               testid="exc-detail-delivery-channel"
               value={n.delivery_channel ?? "null (SMTP HELD)"} />
          <Row label="Read" value={String(!!n.read || !!n.read_at)} />
        </CardContent>
      </Card>
      <Card className="border-neutral-200 rounded-2xl">
        <CardContent className="p-4">
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 mb-2">
            Payload
          </div>
          <pre className="text-[11px] font-mono bg-neutral-50 p-3 rounded overflow-auto max-h-72">
{JSON.stringify(n.payload, null, 2)}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
}

function Row({ label, value, testid }) {
  return (
    <div className="flex items-baseline gap-2"
         {...(testid ? { "data-testid": testid } : {})}>
      <div className="text-[11px] text-neutral-500 min-w-[140px]">{label}</div>
      <div className="text-sm text-neutral-800 font-mono break-all">
        {value ?? "—"}
      </div>
    </div>
  );
}
